<template>
  <div class="home-wrapper">
    <h1></h1>
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted() {
    if (this.$route.name === 'home') {
        this.$router.push('/calendar');

      // if (
      //   this.$store.state.user.permissions.isSuperAdmin ||
      //   this.$store.state.user.permissions.isAdmin
      // ) {
      //   this.$router.push('/calendar');
      // } else if (this.$store.state.user.permissions.isReporter) {
      //   this.$router.push('/reports/own');
      // } else {
      //   this.$router.push('/calendar');
      // }
    }
  }
};
</script>

<style scoped>
h1 {
  color: rgba(8, 63, 117, 1);
  margin: 15px 0;
  text-align: center;
}
</style>